import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, I18nModule, provideDefaultConfig } from '@spartacus/core'
import { TabParagraphContainerComponent } from './tab-paragraph-container.component'
import { PageComponentModule, OutletModule } from '@spartacus/storefront'

@NgModule({
  imports: [CommonModule, PageComponentModule, OutletModule, I18nModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        CMSTabParagraphContainer: {
          component: TabParagraphContainerComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [TabParagraphContainerComponent],
  exports: [TabParagraphContainerComponent],
})
export class TabParagraphContainerModule {}
